import { Paper, Typography, Divider, Box } from '@mui/material';
import React from 'react';

export interface StatsCardProps {
  header: string;
  data: string;
  description: string;
}

export const StatsCard = (props: StatsCardProps) => {
  return (
    <Paper sx={{ 
      height: '170px', 
      minWidth: '200px',
      flex: 1,
      borderRadius: '16px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      border: '1px solid rgba(229, 231, 235, 0.8)',
      background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
    }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ m: '24px', color: '#17052D', fontSize: '14px' }}>
          {props.header}
        </Typography>
        <Divider sx={{ color: '#F7F8FA' }} />
        <Box sx={{ columnGap: '10px', marginTop: '15px', marginLeft: '24px' }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '20px',
              lineHeight: '30px',
              color: '#17052D',
            }}
          >
            {props.data}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#453757' }}>
            {props.description}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};
